import * as React from 'react';
import { LoyaltyPointsEducationContent } from './loyalty-points-education-content';
import { LoyaltyEducationContentType } from 'models/common/loyalty-education';
import { LoyaltyProgramEducationContent } from './loyalty-program-education-content';

interface LoyaltyEducationContentProps {
  type: LoyaltyEducationContentType;
  content: any;
}

export const LoyaltyEducationContent: React.FunctionComponent<LoyaltyEducationContentProps> = ({ type, content }) => {
  switch (type) {
    case LoyaltyEducationContentType.POINTS:
      return <LoyaltyPointsEducationContent content={content} />;
    case LoyaltyEducationContentType.PROGRAM:
      return <LoyaltyProgramEducationContent content={content} />;
    default:
      return null;
  }
};
